import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    banner: Yup.array()
      .min(1, "At least one banner image is required")
      .required("Banner is required"),
    bannerDisplayTime: Yup.string().required("Display time is required")
    // device/branchId validated in BannerForm.handleSubmit based on targetType
  }),
  mapPropsToValues: props => ({
    // targetType: "individual" | "store" | "branch"
    targetType: "individual",
    device: props.editedData
      ? {
          label: props.editedData.email,
          value: props.editedData.email,
          id: props.editedData.deviceTokenId
        }
      : "",
    branchId: "",
    bannerDisplayTime: props?.editedData?.bannerDisplayTime
      ? props?.editedData?.bannerDisplayTime
      : "",
    banner: props?.editedData?.bannersResDTOSet?.length
      ? props?.editedData?.bannersResDTOSet
      : []
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
